







import { Component, Vue } from "vue-property-decorator";
import DashboardMenu from "@/components/dashboard/menu.vue";

@Component({
  components: {
    DashboardMenu
  },
})
export default class DashboardTemplate extends Vue {}
